import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root',
})
export class CollectionInfrastructureModalService {
  constructor(private _modalService: NzModalService) {}

  async openHqRestDueModal(negativeCurrentBalance: any) {
    const { HqRestaurantsDueModalComponent } = await import(
      /* webpackPrefetch: true */ './modals/hq-restaurants-due-modal/hq-restaurants-due-modal.component'
    );
    return this._modalService.create({
      nzClosable: false,
      nzContent: HqRestaurantsDueModalComponent,
      nzComponentParams: { negativeCurrentBalance },
      nzBodyStyle: { padding: '0' },
      nzFooter: null,
      nzWidth: 650,
      nzCentered: true,
    });
  }

  async openPaymentMethodModal(payload: any) {
    const { PaymentMethodModalComponent } = await import(
      /* webpackPrefetch: true */ './modals/payment-method-modal/payment-method-modal.component'
    );
    return this._modalService.create({
      nzClosable: false,
      nzContent: PaymentMethodModalComponent,
      nzComponentParams: { payload },
      nzBodyStyle: { padding: '0' },
      nzFooter: null,
      nzWidth: 450,
      nzCentered: true,
    });
  }

  async openPaymentStatusModal(data: any) {
    const { PaymentStatusModalComponent } = await import(
      /* webpackPrefetch: true */ './modals/payment-status-modal/payment-status-modal.component'
    );
    return this._modalService.create({
      nzClosable: false,
      nzContent: PaymentStatusModalComponent,
      nzComponentParams: { data },
      nzBodyStyle: { padding: '0' },
      nzFooter: null,
      nzWidth: 450,
      nzCentered: true,
    });
  }

  async openLockedPlanModal(data: { type: number }) {
    const { LockedFeatureComponent } = await import(
      /* webpackPrefetch: true */ './modals/locked-feature-modal/locked-feature.component'
    );
    return this._modalService.create({
      nzClosable: false,
      nzContent: LockedFeatureComponent,
      nzComponentParams: { data },
      nzBodyStyle: { padding: '0' },
      nzFooter: null,
      nzWidth: 532,
      nzCentered: true,
    });
  }
}
